import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AvtAjouterMatiereCursusComponent } from '../avt-ajouter-matiere-cursus/avt-ajouter-matiere-cursus.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-avt-matiere-cursus',
  templateUrl: './avt-matiere-cursus.component.html',
  styleUrls: ['./avt-matiere-cursus.component.scss'],
})
export class AvtMatiereCursusComponent implements OnInit {
  @ViewChild('listeMatiereComponen', { static: false })
  listeMatiereComponen: AvtListesComponent;
  @Input() disabled: boolean = false;
  listBtn = [
    {
      name: 'ajouter',
      class: 'colorBlue',
      text: 'Ajouter',
      disabled: this.disabled,
      icon: 'add',
    },
    {
      name: 'enregistrer',
      class: 'colorGreen',
      text: 'Enregistrer',
      disabled: this.disabled,
      icon: 'save',
    },
    {
      name: 'retour',
      class: 'colorGreen',
      text: 'Retour à la liste des cursus',
      disabled: this.disabled,
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: this.disabled,
      icon: 'delete',
    },
  ];
  cursus;
  exist: boolean = true;
  showEnteteFenetre: boolean = true;
  @Input() param_code: string;
  listeAllMatiere;
  listeAllMatiereIsLoadet: boolean = false;
  listeAllSalleIsLoadet: boolean = false;
  listeMatiereCursus;
  listeMatiereCursusInit;
  listeMatiereCursusIsLoadet: boolean = false;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Matiere_Code',
        Lg_Code: '',
        TableRD_Des: 'Matière',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: this.disabled,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'CursusD_TypeSalle',
        Lg_Code: '',
        TableRD_Des: 'Salle',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: this.disabled,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'CursusD_Duree',
        Lg_Code: '',
        TableRD_Des: 'Durée',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: this.disabled,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: 'Total',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  constructor(
    public dialog: MatDialog,
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  ngOnInit() {
    this.cursus = {};
    this.readParamUrl();
    this.getListeAllMatiere();
    this.getListeSalle();
    this.initColumnsEndListeBtn();
  }
  initColumnsEndListeBtn() {
    this.columns.TableRD.forEach((col) => {
      col.TableRD_ReadOnly = this.disabled;
    });
    this.listBtn.forEach((btn) => {
      btn.disabled = this.disabled;
    });
  }
  getListeAllMatiere() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MAT01')
      .subscribe((data) => {
        this.listeAllMatiere = data;
        this.listeAllMatiereIsLoadet = true;
        this.columns.TableRD[0].dataSelect = data.DiverSys;
        this.setListMatiereCursus();
      });
  }
  getListeSalle() {
    this.listeAllSalleIsLoadet = true;
    this.columns.TableRD[1].dataSelect = this.generalService.typeSalle;
    this.setListMatiereCursus();

    // this.generalService.rechercheTable(globalUrls.urlParametre+"&val=SALL01").subscribe(data =>
    // {
    //   this.listeAllSalleIsLoadet = true;
    //   this.columns.TableRD[1].dataSelect = data.DiverSys;
    //   this.setListMatiereCursus();

    // });
  }
  getListMatiereCursus() {
    this.generalService
      .rechercheTable(
        globalUrls.urlApplyCursusD + '&val=' + this.cursus.Cursus_Code
      )
      .subscribe((data) => {
        if (
          data.ApplyCursusD[0].Cursus_Code == null &&
          data.ApplyCursusD[0].Matiere_Code == null &&
          data.ApplyCursusD[0].CursusD_Id == null
        )
          data.ApplyCursusD = [];
        this.listeMatiereCursus = data;
        this.listeMatiereCursusInit = JSON.parse(JSON.stringify(data));
        this.listeMatiereCursusIsLoadet = true;
        this.setListMatiereCursus();
      });
  }
  getCursus() {
    this.generalService
      .rechercheTable(globalUrls.urlApplyCursus + '&val=' + this.param_code)
      .subscribe((cursus) => {
        this.cursus = cursus.ApplyCursus[0];
        this.getListMatiereCursus();
      });
  }

  setListMatiereCursus() {
    if (
      this.listeAllSalleIsLoadet &&
      this.listeMatiereCursusIsLoadet &&
      this.listeAllMatiereIsLoadet
    ) {
      this.listeMatiereComponen.setDataSource(
        this.listeMatiereCursus.ApplyCursusD
      );
    }
  }

  clickBtnHeat(event) {
    switch (event.name) {
      case 'ajouter': {
        this.openDialogAjouter(event.row);
        break;
      }
      case 'enregistrer': {
        this.enregistrer();
        break;
      }
      case 'supprimer': {
        this.supprimer();
        break;
      }
      case 'retour': {
        this.router.navigate(['avt/liste/cursus']);
        break;
      }
    }
  }
  openDialogAjouter(row) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      Cursus_Code: this.cursus.Cursus_Code,
      Cursus_Duree: this.cursus.Cursus_Duree,
      sommeDureeMatiere: this.listeMatiereComponen.getSomme({
        TableRD_Champs: 'CursusD_Duree',
      }),
      listeMatiere: this.listeMatiereComponen.dataSource.data,
    };
    var dialogRef = this.dialog.open(
      AvtAjouterMatiereCursusComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      this.getListMatiereCursus();
    });
  }
  enregistrerCursus() {
    this.generalService.enregisterTable(this.listeMatiereCursus).subscribe(
      (data) => {
        this.getListMatiereCursus();
        this.generalService.dialogSuccess('Enregistré', true);
        this.listBtn[1].disabled = false;
        this.exist = true;
      },
      (erro) => {
        this.generalService.dialogSuccess('Non enregistré', false);
        this.listBtn[1].disabled = false;
        this.exist = true;
      }
    );
  }
  enregistrer() {
    this.exist = false;
    this.listBtn[1].disabled = true;
    var durerChanger: boolean = false;
    for (var i = 0; i < this.listeMatiereCursusInit.ApplyCursusD.length; i++) {
      if (
        this.listeMatiereCursusInit.ApplyCursusD[i].CursusD_Duree !=
        this.listeMatiereCursus.ApplyCursusD[i].CursusD_Duree
      )
        durerChanger = true;
    }
    if (!durerChanger) {
      this.enregistrerCursus();
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        message: 'Vous avez changé la durée du cursus! Voulez-vous continuer',
        btnOk: { class: 'colorRed', icon: 'keyboard_return', text: 'Modifier' },
        btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
      };
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.enregistrerCursus();
        } else {
          this.listBtn[1].disabled = false;
          this.exist = true;
        }
      });
    }
  }
  supprimer() {
    if (
      this.listeMatiereComponen.rows != undefined &&
      this.listeMatiereComponen.rows.length > 0
    ) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var compte = this.listeMatiereComponen.rows.length;
          this.exist = false;
          this.listBtn[3].disabled = true;
          this.listeMatiereComponen.rows.forEach((row) => {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(
              row.CursusD_Id,
              'ApplyCursusDSup'
            );
            if (deleteFn != null) {
              deleteFn.subscribe(
                (data) => {
                  compte--;
                  if (compte == 0) {
                    this.getListMatiereCursus();
                    this.exist = true;
                    this.listBtn[1].disabled = false;
                  }
                  this.generalService.dialogSuccess('Elément supprimer', true);
                },
                (error) => {
                  this.generalService.dialogSuccess(
                    'Elément non supprimé',
                    false
                  );
                  this.exist = true;
                  this.listBtn[1].disabled = false;
                }
              );
            }
          });
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ou plusieurs lignes',
        false
      );
  }
  readParamUrl() {
    if (!this.generalService.isNotEmpty(this.param_code)) {
      this.route.params.subscribe((params) => {
        this.param_code = params['param_code'];
        this.getCursus();
      });
    } else {
      this.showEnteteFenetre = false;
      this.getCursus();
      this.listBtn.splice(2, 1);
    }
  }
}
